import React, { useContext } from 'react';
import { FlexLayout } from '../flex/FlexLayout.component';
import { FlexLayoutModifier } from '../flex/flex.constants';
import { FlexItem } from '../flex/FlexItem.component';
import IconWithText from '../icon-with-text/IconWithText.component';
import { EntrySubmitProps } from '../../pages/ai-chat/ai-chat.models';
import { getBrandName } from '../../pages/ai-chat/ai-chat.utilities';
import { AppContext } from '../app/AppProvider.component';
import { getPromptExampleConfigsForCurrentChat } from './example-prompts.utilities';

export type ExamplePromptsProps = {
  handleChatSubmit: (params: EntrySubmitProps) => void;
}

export const ExamplePrompts = (props: ExamplePromptsProps): JSX.Element => {

  const {
    appState,
  } = useContext(AppContext);

  const { handleChatSubmit } = props;

  const promptExampleConfigs = getPromptExampleConfigsForCurrentChat(appState.chatUserRole);

  if (promptExampleConfigs.length === 0) {
    return null;
  }

  return (
    <div className="c-naa-prompt-example-list">
      <h4 className="o-els-container u-els-text-center">
        Try an example prompt. You can have {getBrandName(appState)}...
      </h4>
      <FlexLayout modifiers={[FlexLayoutModifier.GUTTERS, FlexLayoutModifier.WRAP_AT_TABLET]}>
        {
          promptExampleConfigs.map((config) => (
            <FlexItem
              key={config.type}
              classes={['c-naa-prompt-example-list__item u-els-width-1o3 u-els-width-1o1@tablet u-els-margin-bottom@tablet']}
            >
              <button
                className="c-naa-prompt-example-list__example u-els-width-1o1@tablet"
                type="button"
                onClick={() => {
                  handleChatSubmit({
                    prompt: config.fullPrompt,
                    followUpQuestion: null,
                    isNewChat: false,
                    isAppLinkQuery: false,
                    isPromptExample: true,
                    chatMode: appState.chatModeType,
                  });
                }}
              >
                <div className="u-els-margin-bottom-1o2">
                  <IconWithText
                    iconName={config.iconName}
                    iconPrefix={config.iconPrefix}
                    iconClass={config.iconClass}
                  >
                    <strong>{config.title}</strong>
                  </IconWithText>
                </div>
                <div className="u-els-padding-left-1x1o2">{config.cardText}</div>
              </button>
            </FlexItem>
          ))
        }
      </FlexLayout>
    </div>
  );
};
